import { render } from "./sv-ellipsis.vue?vue&type=template&id=047b5df7&scoped=true&ts=true"
import script from "./sv-ellipsis.ts?vue&type=script&lang=ts&external"
export * from "./sv-ellipsis.ts?vue&type=script&lang=ts&external"

import "./sv-ellipsis.vue?vue&type=style&index=0&id=047b5df7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-047b5df7"]])

export default __exports__